<div class="container">
    <div class="text">
        <h1>{{ 'modalFeedback.title' | translate}}</h1>
        <p class="first-p">{{ 'modalFeedback.subtitle' | translate}}</p>
        <p class="second-p">{{ 'modalFeedback.secondP' | translate}}</p>
    </div>
    <form [formGroup]="feedbackForm">
        <app-star-rating
            [stars]="5"
            [(rating)]="rating"
            (ratingChange)="onRate($event)"
        ></app-star-rating>       
        <textarea
            formControlName="notes"
            rows="5"
            cols="50"
            placeholder="{{ 'modalFeedback.placeholder' | translate}}"
        ></textarea>
    </form>
    <ds-button
        class="button-send"
        (click)="sendFeedback()"
        [text]="'modalFeedback.buttonText' | translate"
        style="display: block; justify-items: center">
    </ds-button>
</div>